import PriceUpdater from "../../../component/PriceUpdater";

const priceUpdater = {
  path: "price-updater",
  userMenu: {
    group: 1,
    order: 20,
    label: "Price Updater",
    entityType: "all",
    allowedRole: "all",
    auth: ["authenticated"],
  },
  route: {
    index: {
      element: <PriceUpdater />,
      allowedRole: "all",
      entityType: "all",
      auth: ["authenticated"],
    },
  },
};

export default priceUpdater;

